<template>
  <div class="test-view">
    <div class="backbtn">
      <v-btn @click="onBack({})" class="right-btn cust-btn" color="primary"
        >Back
      </v-btn>
    </div>
    <v-card
      class="mx-auto normal-card instructions-hg chart-padding same-height-card pie-chart-area-mobile-responsive"
    >
      <div class="pie-chart-area" v-for="topic in topics" :key="topic.id">
        <div class="px-3 text-center topictitle">
          <v-tooltip top content-class="cust-new-tooltip-top">
            <template v-slot:activator="{ on }">
              <div class="max-char topictitle" v-on="on">{{ topic.name }}</div>
            </template>
            <span>{{ topic.name }}</span>
          </v-tooltip>
        </div>
        <div class="pie-chart-block">
          <PieChart
            :seriesData="topic.series"
            :height="150"
            :chartOptions="topic.chartOptions"
          />
        </div>
        <div class="px-3 text-center">Health: {{ topic.health }}%</div>
        <div class="practicebtnincenter">
          <v-btn
            v-if="user&&user.role_code == 'ST' && !isAltitudeInstitute() && (checkBoostupSubscription() || isOnlineInstitute)"
            @click="requestCreateTest(topic.id)"
            class="right-btn cust-btn"
            color="primary"
            >Practice Now
          </v-btn>
        </div>
      </div>
    </v-card>
    <AlertBox
			:width="modalwidth"
			:onClose="onClose"
			:component="cComponent"
			:status="status"
			:data="alertBoxData"
		/>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import PieChart from "@/components/Charts/PieChart.vue";
import constants from "@/utils/constants.js";
import moment from "moment";

export default {
  name: "TopicsPerChapterHealth",
  components: {
    PieChart,
  },
  mounted() {
      if (this.compareEvent(constants.EVENT.CREATE_PRACTICE_SESSION)) {
        this.removeEvent()
        this.requestCreateTest();
      }
      this.initializeData();
      localStorage.removeItem("prevPath");
      localStorage.setItem("prevPath", this.$route.name);
    

  },
  data() {
    return {
      topics: [],
      series: [0, 0],
      chartOptions: {
        chart: {
          type: "pie",
        },
        labels: [],
        legend: {
          show: false,
        },
        fill: {},
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          enabled: false,
        },
        states: {
          hover: {
            filter: {
              type: "none",
            },
          },
        },
      },
      chapterName: "",
      question_types: constants.QUESTION_TYPES_PS[2],
      cComponent: "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp",
      modalwidth: '500px',
      status: false,
      alertBoxData: {},
    };
  },
  computed: {
    ...mapGetters("healthStore", ["selectedChapter"]),
    ...mapState("userStore", ["user",'myInstitute']),
    isOnlineInstitute(){
				return constants.institute_ids.includes(this.myInstitute.id)
			}
  },
  methods: {
    ...mapActions({
      setSelectedSubjectData: "healthStore/setSelectedSubjectData",
      getMyHealthData: "healthStore/getMyHealthData",
      setSelectedChapter: "healthStore/setSelectedChapter",
      getChildren: "resultStore/getChildren",
      getHealthData: "healthStore/getHealthData",
      createTestForPracticeSession: "testStore/createTestForPracticeSession",
    }),
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    initializeData() {
      if (this.$route.params) {
        this.getTopics();
      }
    },
    getColor(percentage) {
      let color = "";
      if (percentage > 65) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
      } else if (percentage > 19) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
      } else {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
      }
      return color;
    },
    getTopics() {
      let chapter_id = this.$route.params.chapter_id;
      let student_id = this.$route.params.student_id;
      let me = this;
      let postData = {
        parent_id: [parseInt(chapter_id)],
        student_id: parseInt(student_id),
        required_health: 1,
      };
      this.$root.showLoader = true;
      this.getChildren(postData)
        .then((response) => {
          me.topics = response[0].chidren.map((t) => {
            return {
              name: t.title,
              id: t.id,
              health: t.health,
            };
          });
          this.chapterName = response[0].title;
          this.$root.showLoader = false;
          me.processMyHealthData();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },

    getIdsForHealths() {
      let topicIds = [];
      topicIds = this.topics.map((t) => t.id);
      this.getHealth(topicIds);
    },

    getHealth(topicIds) {
      let me = this;
      let student_id = this.$route.params.student_id;
      let postData = {
        data_type_ids: topicIds,
        student_id: student_id,
      };
      this.$root.showLoader = true;
      this.getHealthData(postData)
        .then((response) => {
          this.$root.showLoader = false;
          me.processMyHealthData(response);
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    processMyHealthData(response) {
      let topics = this.topics;
      topics.map((topic) => {
        let series = [];
        let topicHealth = topic.health;
        let chartOptions = _.cloneDeep(this.chartOptions);
        let colors = [this.getColor(topicHealth), "#efeeee"];
        chartOptions.fill.colors = colors;
        series[0] = topicHealth;
        series[1] = 100 - topicHealth;
        topic.series = series;
        topic.chartOptions = chartOptions;
        topic.health = topicHealth;
      });
      this.topics = topics;
      this.addBreadCrumbChilde([
        {
          text: this.$route.params.subject,
          disabled: false,
        },
        {
          text: this.chapterName,
          disabled: false,
        },
      ]);
    },
    onBack() {
      let subject = this.$route.params.subject;
      this.$router.push({
        name: "chapters-health",
        params: { subject_name: subject, studentId: this.$route.params.student_id},
      });
    },
    onPracticeNow() {},
    requestCreateTest(topicId) {
      if (!this.checkStudentUpgraded()) {
      
        let reqData = {
          test_name: this.testName, // from constansts.js
          chapter_id: this.$route.params.chapter_id ? [this.$route.params.chapter_id] :[],
          subject_id: this.$route.params.subject_id,
          required_pyq: 0,
          topic_id: [topicId],
          question_types: this.question_types.value,
          test_sub_type: this.testSubType, // from constansts.js
          test_type: this.testType, // from constansts.js
        };
        this.createTestForPracticeSession(reqData)
          .then((response) => {
            this.removeSessionData();
            localStorage.setItem(
              "session_start",
              response.practice_session.start_time
            );
            localStorage.setItem("previousPath", this.$route.path);
            this.$router.push({
              name: "practice-session-question-view",
              params: {
                practice_session_id: response.practice_session.id,
                subject_id: response.practice_session.subject_id,
                test_id: response.id,
                topicsSelected: topicId && topicId !== null && topicId !== 0 ? 1 : 0,
              },
            });
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
        }
    },
    checkStudentUpgraded() {
				this.status = this.checkStudentUpgradedHelper(
					this.user.subscription_details
				);
				this.cComponent =
					"components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp";
				(this.modalWidth = "500px"), (this.alertBoxData = {});
				return this.status;
				
			},
    redirectTo(route) {
      this.$router.push({
        name: route,
      });
    },
    onClose(data) {
				this.status = data.status;
				if (data && data.redirectTo) {
					this.redirectTo(data.redirectTo);
				}
		},
  },
};
</script>
